var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseAdapter } from './base';
import { PlatformEnum } from '../utils';
import { EnvironmentDetector } from '../core';
/**
 * Web 平台适配器
 * 直接映射 window 和 document 对象到统一的 Platform 接口
 */
export class WebAdapter extends BaseAdapter {
    constructor() {
        super();
        this.platformType = PlatformEnum.Web;
        this.env = EnvironmentDetector.getEnvironmentInfo();
        this.capabilities = EnvironmentDetector.detectCapabilities(this.platformType);
    }
    getDefaultLocalStorage() {
        const nativeStorage = window.localStorage;
        return {
            get length() {
                return nativeStorage.length;
            },
            key: function (index) {
                return nativeStorage.key(index);
            },
            clear: function () {
                nativeStorage.clear();
            },
            /** 特别小心，这里是异步读取！！为了和 LiteApp 保持一致 */
            getItem: function (key) {
                return __awaiter(this, void 0, void 0, function* () {
                    return nativeStorage.getItem(key);
                });
            },
            removeItem: function (key) {
                nativeStorage.removeItem(key);
            },
            setItem: function (key, value) {
                nativeStorage.setItem(key, value);
            },
        };
    }
    /**
     * 获取Cookie
     * @param {string} name - 要获取的Cookie名称
     * @returns {string} Cookie值或空字符串（如果不存在）
     */
    getDefaultCookie(name) {
        const cookies = document.cookie;
        const regex = new RegExp(`(^| )${name}=([^;]+)`);
        const match = cookies.match(regex);
        return (match === null || match === void 0 ? void 0 : match[2]) ? decodeURIComponent(match[2]) : '';
    }
    /**
     * 设置Cookie
     * @param {string} name - Cookie名称
     * @param {string} value - Cookie值
     * @param {number} days - 过期天数（默认7天）
     * @param {string} path - 有效路径（默认'/'）
     * @param {string} domain - 有效域名（默认当前域名）
     * @param {boolean} secure - 是否仅HTTPS传输（默认false）
     */
    setDefaultCookie(options) {
        const { name, value, days = 7, path = '/', domain = '', secure = false } = options;
        if (!name || !value) {
            console.error('web setCookie name and value are required');
            return;
        }
        let cookieString = `${name}=${encodeURIComponent(value)}`;
        // 设置过期时间
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            cookieString += `; expires=${date.toUTCString()}`;
        }
        // 设置路径
        cookieString += `; path=${path}`;
        // 设置域名
        if (domain) {
            cookieString += `; domain=${domain}`;
        }
        // 设置Secure标志
        if (secure) {
            cookieString += '; Secure';
        }
        document.cookie = cookieString;
    }
    // protected doDefaultFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    //   return window.fetch(input, init);
    // }
    getDefaultNavigator() {
        return window.navigator;
    }
    getDefaultLocation() {
        return window.location;
    }
    getDefaultDocument() {
        return document;
    }
    /** 设置全局数据配置（增量合并） */
    setGlobalDataConfig(config) { }
    /** 获取全局数据配置（只读） */
    getGlobalDataConfig() {
        return {};
    }
}
//# sourceMappingURL=web.js.map